// available selectors - add more as needed
import type { CookieState } from './types'

export const selectedCookies = (state: { cookies: CookieState }) => state.cookies
